app.controller("StudentSelectionController", ["$scope", "Students", "$uibModal", "$stateParams", "AuthService", "Selection",
    function ($scope, Students, $uibModal, $stateParams, AuthService, Selection) {
        $scope.majorCredits = 0;
        $scope.electiveCredits = 0;
        AuthService.getUserData().then(function (user) {
            $scope.profile = user.profiles.filter(function (p) {
                return p.type === 'student' && p.state === 'active'
            })[0];
            $scope.program = $scope.profile.program;
            $scope.user = user;
            loadActivations();
        });

        function loadActivations() {
            Selection.activationsForStudent({
                program: $scope.program,
                studentId: $scope.profile._id
            }).then(function (activations) {
                var creditsCounted = ['proved', 'processing'];
                $scope.majorCredits = _(activations).filter(function (a) {
                    return _.includes(creditsCounted, a.selectionState)
                }).sumBy('subjectWrapper.credits');
                activations.sort(function (a, b) {
                    if (a.selectionState && b.selectionState || !a.selectionState && !b.selectionState) {
                        return a.subjectWrapper.semester > b.subjectWrapper.semester
                    } else if (!a.selectionStart) {
                        return 1;
                    }
                });
                return $scope.activations = activations;
            });
        }

        $scope.add = function (subjectActivation) {
            Selection.addSelection({
                student: $scope.profile._id,
                subjectActivation: subjectActivation
            }).then(function (resp) {
                console.log(resp);
                loadActivations()
            });
        };
    }
]);